export default "__VITE_ASSET__DIs0WOH9__"